import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Counter } from "../../Counter/index.js";
import { P, Span } from "../../Text/index.js";
function TravelerLineItem({ label, min = 1, max, count = min, subLabel, onChange }) {
    return /*#__PURE__*/ jsxs("div", {
        className: "h-13 my-2 flex w-full items-center justify-between gap-3",
        children: [
            /*#__PURE__*/ jsxs(P, {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body1",
                        children: label
                    }),
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body3",
                        children: subLabel
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Counter, {
                label: label,
                min: min,
                max: max,
                value: count,
                handleValueChange: onChange
            })
        ]
    });
}
const TravelerLineItems_TravelerLineItem = /*#__PURE__*/ memo(TravelerLineItem);
export { TravelerLineItem, TravelerLineItems_TravelerLineItem as default };
